import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes, {bool} from 'prop-types';
import MACAddressInput from "./MACAddressInput";
import {
    devicesClearErrors,
    devicesDeleteData,
    devicesSaveEdit,
    reinitiateDevice
} from "../state/action/deviceActions";
import Icon, {CAMERA, CLOSE, CLOUD_UPLOAD, KEYBOARD} from "./Icon";
import {DEVICE_STATUS, getEpNumber, validateMacFormat, validateMacUnique} from "../util/DeviceUtils";
import DeviceErrorList from "./DeviceErrorList";
import Scanner from "./Scanner";
import DeviceQR from "../domain/DeviceQR";

import '../style/DeviceDisplay.css';
import '../style/General.css';
import {AppError} from "../constant/appAlerts";
import {errorListPush} from "../state/action/alertActions";
import {BLANK_MAC_VALUE} from "../constant/appConstants";


const initialState = Object.freeze(
    {
        scannerKey: 0,
        scanner: false,
        editing: false,
        edits: Object.freeze({}),
        replaceButtonClicked: false
    }
);

export class DeviceDisplay extends Component {
    state = initialState;

    /**
     * Validates the input item number to the number that is currently pulled from the server.
     *
     * TODO: This will have to be reworked in future versions to account for alternate situations
     * (e.g. no item number for new devices, item numbers with cosmetic diff)
     */
    validateItemNumber(itemNumber) {
        return this.props.device.itemNumber === itemNumber;
    }

    handleScannerDetect = result => {
        try {
            /* There is no replaceAll therefore split and join for replacing all instances of special chars */
            const mac = result.mac.split(':').join('').split('-').join('');
            const itemNumber = result.in;
            if (!validateMacFormat(mac)) {
                this.props.handleErrorPush(AppError.INCORRECT_MAC_FORMAT);
                this.incrementScannerKey();
            } else if (!validateMacUnique(mac, this.props.allDevices)) {
                this.props.handleErrorPush(AppError.MAC_ADDRESS_IN_USE);
                this.incrementScannerKey();
            } else if (!this.validateItemNumber(itemNumber)) {
                this.props.handleErrorPush(AppError.INCORRECT_DEVICE_TYPE);
                this.incrementScannerKey();
            } else {
                this.submitSave({mac: mac});
                this.toggleEditOff();
            }
        } catch (e) {
            this.incrementScannerKey();
            this.props.handleErrorPush(AppError.SCANNER_PARSE_ERROR);
        }
    };

    toggleCameraOn = () => {
        this.setState({scanner: true, editing: true});
    };

    toggleEditType = () => {
        this.setState({scanner: !this.state.scanner});
    };

    toggleEditOff = () => {
        this.setState({editing: false, edits: initialState.edits, scanner: initialState.scanner});
    };

    submitEdit = (edit) => {
        /*
            This will validate the mac is unique on every char entry which could be heavy for the app.
            Refactor would take a rework of when the keyboard submits edits to this component.
            TODO: Possible point of refactor.
        */
        if (edit.mac && !validateMacUnique(edit.mac, this.props.allDevices)) {
            this.props.handleErrorPush(AppError.MAC_ADDRESS_IN_USE);
        } else {
            this.setState({edits: {...this.state.edits, ...edit}});
        }
    };

    submitStateSave = () => {
        Object.keys(this.state.edits).length > 0 && this.props.handleEditSave(this.state.edits);
        this.toggleEditOff();
    };

    submitSave = (edits) => {
        if (edits) {
            Object.keys(edits).length > 0 && this.props.handleEditSave(edits);
        }
        this.toggleEditOff();
    };

    submitRestore = () => {
        this.props.handleDeleteClick();
        this.toggleEditOff();
        if (this.props.isReplaceableDevice) {
            this.setState({replaceButtonClicked: false});
        }
    };

    getHeaderColor = () => {
        switch (true) {
            case this.state.editing:
                return '#bbb9b9';
            default:
                return undefined;
        }
    };

    incrementScannerKey = () => {
        this.setState({scannerKey: this.state.scannerKey + 1});
    };

    editable = () => {
        return this.props.device.editable;
    };

    hasEdits = () => {
        return Object.keys(this.props.device.metadata.edits).length > 0;
    };

    hasEditsReplaceDevice = () => {
        let replacementDevice = this.props.replacementDevice;
        return replacementDevice ? Object.keys(replacementDevice.metadata.edits).length > 0 : false;
    };

    isLeadDevice = () => {
        return this.props.device.leadDevice;
    };

    handleReplace = () => {
        this.setState({replaceButtonClicked: true});
    };

    handleReinitiateDevice = () => {
        this.props.handleReinitiate(new Array(this.props.device));
    }

    renderRightMenuButton = () => {
        return (
            <React.Fragment>
                <div className={'separator'}/>
                {
                    (this.hasEdits() || this.hasEditsReplaceDevice()) ?
                        <div onClick={this.submitRestore}
                             className={'device_display-menu-button device_display-menu-button-delete'}>
                            <Icon iconName={CLOSE}/>
                        </div>
                        :
                        <div>
                            {this.props.isReplaceableDevice ?
                                <div>
                                    <div onClick={this.toggleCameraOn}
                                         className={'device_display-menu-button device_display-menu-button-edit'}>
                                        <Icon iconName={CAMERA}/>
                                    </div>
                                    <div onClick={this.submitRestore}
                                         className={'device_display-menu-button device_display-menu-button-delete'}>
                                        <Icon iconName={CLOSE}/>
                                    </div>
                                </div>
                                :
                                <div onClick={this.toggleCameraOn}
                                     className={'device_display-menu-button device_display-menu-button-edit'}>
                                    <Icon iconName={CAMERA}/>
                                </div>
                            }
                        </div>
                }
            </React.Fragment>
        );
    }

    renderMenu = () => {
        const device = this.props.device;
        return (
            <div className={'device_display-menu'}
                 style={{backgroundColor: this.getHeaderColor()}}>
                <div className={'device_display-menu-left'}>
                    A{getEpNumber(this.props.device)}
                    {
                        (device.metadata.status === DEVICE_STATUS.new || this.hasEdits() || this.hasEditsReplaceDevice()) &&
                        <div className={'device_display-menu-button device_display-menu-left'}>
                            <Icon iconName={CLOUD_UPLOAD}/>
                        </div>
                    }
                </div>
                <div>
                    {
                        this.isLeadDevice() &&
                        <div className={'device_display-lead-right'}>LEAD</div>
                    }
                    {
                        (this.editable() || this.hasEdits() || this.hasEditsReplaceDevice() || (this.props.isReplaceableDevice && this.state.replaceButtonClicked)) &&
                        <div className={'device_display-menu-right'}>
                            {
                                this.state.editing ?
                                    <React.Fragment>
                                        <div onClick={this.toggleEditType}
                                             className={'device_display-menu-button device_display-menu-button-edit'}>
                                            {this.state.scanner ? <Icon iconName={KEYBOARD}/> : <Icon iconName={CAMERA}/>}
                                        </div>
                                        <div onClick={this.toggleEditOff}
                                             className={'device_display-menu-button device_display-menu-button-cancel'}>
                                            <Icon iconName={CLOSE}/>
                                        </div>
                                    </React.Fragment>
                                    :
                                    <React.Fragment>
                                        {this.renderRightMenuButton()}
                                    </React.Fragment>
                            }
                        </div>
                    }
                </div>
            </div>
        );
    };

    renderMacAddressInput = (device) => {
        return (
            <div>
                <p>MAC address of new device:</p>
                <div className={'device_display-mac-container'}>
                    <MACAddressInput
                        mac={this.state.edits.mac || device.metadata.edits.mac || device.mac}
                        submitEdit={this.submitEdit}
                        editable={this.state.editing}
                        complete={this.submitStateSave}>
                    </MACAddressInput>
                </div>
            </div>
        );
    }

    render() {
        const device = this.props.device;

        return (
            <div className={'card'}>
                {this.renderMenu()}
                <div className={'device_display-wrapper'}>
                    {
                        this.state.scanner && this.state.editing ?
                            <div>
                                <Scanner
                                    key={this.state.scannerKey}
                                    validate={DeviceQR.isDeviceQR}
                                    onDetected={this.handleScannerDetect}
                                    onValidateFail={this.incrementScannerKey}
                                />
                            </div>
                            :
                            <React.Fragment>
                                {
                                    device.metadata.errorMap &&
                                    <DeviceErrorList
                                        clearErrors={this.props.handleClearErrors}
                                        errors={device.metadata.errorMap}/>
                                }
                                <div className={'device_display-body'}>
                                    <div>
                                        <div>
                                            {device.description}
                                        </div>
                                        <div>
                                            {device.itemNumber}
                                        </div>
                                        {
                                            (this.props.isReplaceableDevice) ?
                                                <MACAddressInput
                                                    mac={device.mac}
                                                    submitEdit={undefined}
                                                    editable={false}
                                                    complete={undefined}/>
                                                :
                                                <MACAddressInput
                                                    mac={this.state.edits.mac || device.metadata.edits.mac || device.mac}
                                                    submitEdit={this.submitEdit}
                                                    editable={this.state.editing}
                                                    complete={this.submitStateSave}
                                                />
                                        }
                                    </div>
                                    <div className={'device_display-group-button-container'}>
                                        {
                                            (this.props.device.mac !== BLANK_MAC_VALUE && (!this.props.isReplaceableDevice || !this.state.replaceButtonClicked)) &&
                                            <button className={'device_display-device-action-button'}
                                                    onClick={this.handleReinitiateDevice}>
                                                Reinitiate Provisioning</button>
                                        }
                                        {
                                            this.props.isReplaceableDevice && !this.state.replaceButtonClicked && !this.hasEditsReplaceDevice() &&
                                            <button className={'device_display-device-action-button'}
                                                    onClick={this.handleReplace}>
                                                Replace
                                            </button>
                                        }
                                    </div>
                                </div>
                                {
                                    this.props.replacementDevice && (this.hasEditsReplaceDevice() || this.state.replaceButtonClicked)
                                    && this.renderMacAddressInput(this.props.replacementDevice)
                                }
                            </React.Fragment>
                    }
                </div>
            </div>
        );
    }
}

const Device = {
    equipDetailsId: PropTypes.any.isRequired,
    mac: PropTypes.string.isRequired,
    description: PropTypes.string,
    epNumber: PropTypes.any,
    itemNumber: PropTypes.string,
    metadata: PropTypes.shape({
        status: PropTypes.string.isRequired,
        edits: PropTypes.any,
        errorMap: PropTypes.any
    })
}

DeviceDisplay.propTypes = {
    //Given
    deviceId: PropTypes.any.isRequired,
    //Injected
    device: PropTypes.shape(Device).isRequired,
    replacementDeviceId: PropTypes.any,
    replacementDevice: PropTypes.shape(Device),
    isReplaceableDevice: bool,
    /* All devices reference added to facilitate validation against existing devices */
    allDevices: PropTypes.object
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const deviceId = ownProps.deviceId;
    const replacementDeviceId = ownProps.replacementDeviceId;
    return {
        handleDeleteClick: () => {
            dispatch(devicesDeleteData(replacementDeviceId ? replacementDeviceId : deviceId));
        },
        handleEditSave: (edits) => {
            dispatch(devicesSaveEdit(replacementDeviceId ? replacementDeviceId : deviceId)(edits));
        },
        handleClearErrors: () => {
            dispatch(devicesClearErrors(deviceId));
        },
        handleErrorPush: (error) => {
            dispatch(errorListPush(error));
        },
        handleReinitiate: (devices) => {
            reinitiateDevice(devices)(dispatch);
        }
    };
};

const mapStateToProps = (state, ownProps) => {
    const {device} = state;
    let output = {...device[ownProps.deviceId]};
    let result = {
        device: output,
        allDevices: device
    }

    if (ownProps.replacementDeviceId) {
        result.replacementDevice = {...device[ownProps.replacementDeviceId]}
    }

    return result;
};

export default connect(mapStateToProps, mapDispatchToProps)(DeviceDisplay);


// WEBPACK FOOTER //
// ./src/component/DeviceDisplay.jsx